import {
  START_LOADING,
  STOP_LOADING,
  SUCCESS,
  GET_TIME_TYPE_LIST,
} from "../types/index";
import * as api from "../api/index.js";
import { handleApiError } from "Helper";
import { toast } from "react-toastify";

export const getTimeType = () => async (dispatch) => {
  dispatch({ type: START_LOADING });
  try {
    const datas = await api.getTimeTypesList();
    dispatch({ type: GET_TIME_TYPE_LIST, payload: datas.data });
    dispatch({ type: SUCCESS, payload: datas?.message });
  } catch (error) {
    handleApiError(error);
  } finally {
    dispatch({ type: STOP_LOADING });
  }
};

export const editTimeType = (id, data) => async (dispatch) => {
  try {
    await api.editTimeType(id, data);
    toast.success(`Time Type '${data?.name}' has been updated.`);
    await dispatch(getTimeType());
  } catch (error) {
    toast.error("Error occurred while updating");
    handleApiError(error);
  }
};

export const addTime = (data) => async (dispatch) => {
  try {
    await api.addTimeType(data);
    toast.success("Time Type Added Successfully");
    await dispatch(getTimeType());
  } catch (error) {
    toast.error("Error occurred while adding");
    handleApiError(error);
  }
};
